
import request from "../../../core/wrappers/axios-wrapper";
import { ApiURL } from "../../../types/constants/apiUrls/api-urls";
import { RequestType } from "../../../types/enums/request-enums";
 //#region comment metod
const LcwMoneyCashInOut = (data: any): Promise<any>  =>
request({
  url: ApiURL.Command.LcwMoneyCashInOut,
  method: RequestType.POST,
  data,
}); 
const LcwMoneyCommand = {
  LcwMoneyCashInOut
};

export default LcwMoneyCommand;
